import { render, staticRenderFns } from "./transactionNumberSplit.vue?vue&type=template&id=b90bdecc&scoped=true&"
import script from "./transactionNumberSplit.vue?vue&type=script&lang=js&"
export * from "./transactionNumberSplit.vue?vue&type=script&lang=js&"
import style0 from "./transactionNumberSplit.vue?vue&type=style&index=0&id=b90bdecc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90bdecc",
  null
  
)

export default component.exports